import router from './router'
import { getToken } from '@/utils/auth'
import store from '@/store'


router.beforeEach((to, from, next) => {
    // to and from are both route objects. must call `next`.
    let token = getToken()
    if (token) { // 刷新页面后，重新获取用户信息
        if (!store.state.auth.userInfo) {
            store.dispatch('auth/fetchUserInfo').catch(() => {})
            next()
            return
        }
    } else { // 未登录
        if (to.meta.requireAuth) {
            store.dispatch('auth/requireAuthentication')
            next(false)
            return
        }
    }
    next()
})